import { colors } from 'theme/colors'

const DISABLED_FONT_COLOR = colors.COOL[400]

export const SHARED_STYLES = {
  disabledFont: { color: DISABLED_FONT_COLOR },
  disabledInputBox: {
    backgroundColor: colors.WHITE,
    border: `1px solid ${colors.COOL[400]}`,
    borderRadius: '4px',
    color: colors.COOL[400],
  },
  disabledInput: {
    '& .MuiInputLabel-root': {
      color: colors.COOL[400],
    },
    '& .MuiInputBase-root': {
      backgroundColor: colors.WHITE,
      border: 'none',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
  dropdownOptions: {
    maxHeight: '300px',
    overflow: 'auto',
  },
  readOnlyInput: {
    '& .MuiFormLabel-root': {
      color: `${colors.GREY[800]} !important`,
    },
    '& .MuiInputBase-root': {
      backgroundColor: colors.GREY[100],
      border: 'none',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInputBase-input.Mui-disabled': {
      backgroundColor: colors.GREY[100],
      WebkitTextFillColor: colors.COOL[900],
    },
  },
}
